export const MORE_FILTERS_ID = 'moreFiltersPanel';
export const SAVE_SEARCHES_LIMIT = 10;
export const SAVED_FILTERS_FORM = 'savedFiltersForm';
export const SAVE_SEARCH_FORM = 'filterBarSaveSearchForm';
export const COLUMNS_MODAL = 'columnsModal';